import type { Ref } from "react";
import React, { forwardRef } from "react";

import type { IFileHandler } from "./types";

import { FileCard } from "@/components/atoms/fileCard";
import { FileInput } from "@/components/formControls";
import { useFileHandler } from "@/hooks/useFileHandler";
import { useFileStore } from "@/stores/fileStore";

const forwardedFileHandler = forwardRef(function FileHandler(
  props: IFileHandler,
  ref: Ref<HTMLInputElement>,
) {
  const { groupFileID, canUpload,  ...rest } = props;

  // rerender when progress modify
  useFileStore((state) => state.progressModifySignal);

  const fileHandler = useFileHandler({ groupFilesID: groupFileID });

  function fileInputChangeHandler(value: File[]) {
    for (const element of value) {
      fileHandler.add(element);
    }
  }

  return (
    <>
      <FileInput
        {...rest}
        ref={ref}
        value={fileHandler.getAllFiles().map((item) => item[1].file)}
        onChangeValue={fileInputChangeHandler}
      />
      <div className={"d-flex-column gap-m1 mt-l1"}>
        {fileHandler.getAllFiles().map((item) => {
          const metadata = item[1];
          const file = metadata.file;

          return (
            <FileCard
              key={item[0]}
              fileID={item[0]}
              canUpload={canUpload}
              status={metadata?.status}
              uploadedPercentage={metadata?.percent}
              onDelete={fileHandler.deleteFile}
              onCancel={fileHandler.cancel}
              onUpload={fileHandler.uploadFile}
              file={file}
            />
          );
        })}
      </div>
    </>
  );
});

export const FileHandler = React.memo(forwardedFileHandler);
